import React, { useState } from "react";
import moment from "moment";
import { Form, Table, Badge, Dropdown, DropdownButton, Image, Modal } from "react-bootstrap";
import { COLOR_APP, COLOR_WHITE, LINEAR_GRADIENT_BG_SP } from "../../const";
import { convertOrderStatus } from "../../helper";
import EmptyOrderList from "../../components/EmptyComponent";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { BsQuestionLg } from "react-icons/bs";
import { MdCheckCircle, MdOutlineInfo } from "react-icons/md";
import _ from "lodash";
import { successSwal } from "../../helper/sweetalert";
import { convertDeliveryMethod, numberFormat } from "../../helper";
import { imageRender } from "../../const";
import { useQuery } from "@apollo/client";
import { GET_ORDER_GROUPS_V2 } from "../../apollo/ordergroup/query";
import { useHistory } from "react-router-dom";
import SalepageOrderDetail from "./SalepageOrderDetail";
import ReactPaginate from "react-paginate";
import { useTranslation } from "react-i18next";

function SalepageOrderList() {
  const history = useHistory();
  const { t } = useTranslation();
  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const [_limit, setLimit] = useState(20);
  const [_skip, setSkip] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedOrderGroup, setSelectedOrderGroup] = useState(null);
  // Placeholder states for features that might need implementation
  const [showDetailModal, setshowDetailModal] = useState(false);
  const [showImageModal, setshowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const { data, loading, error, refetch } = useQuery(GET_ORDER_GROUPS_V2, {
    variables: {
      where: {
        shop: shopId,
        isDeleted: false,
        type:"SALE_PAGE"
      },
      limit: _limit,
      skip: (_skip - 1) * _limit,
      orderBy: "createdAt_DESC",
    },
    fetchPolicy: "cache-and-network",
  });

  const orderGroupList = data?.orderGroupsV2?.data || [];
  const orderGroupTotal = data?.orderGroupsV2?.total || 0;

  const onSeletedAllOrder = () => {
    if (isSelectAll) {
      setSelectedIds([]);
      setIsSelectAll(false);
    } else {
      setSelectedIds(orderGroupList.map((o) => o.id));
      setIsSelectAll(true);
    }
  };

  const getSeletedOrder = (id, order) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((i) => i !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const setOrderGroupDownload = (list) => {
    // Implement download logic or state if needed
  };

  const gotoOrderGroupDetail = (id, order) => {
    // history.push(`/order-detail/${id}`, { state: order });
  };

  const handleOrderStatusChange = () => {
    console.log("Handle status change");
  };

  const handleCreatePreOrder = (order) => {
    console.log("Create pre order", order);
  };
  
  const getCfMessage = null; // or implement if logic known
  const isUseLogistics = true; // Default or fetch from settings


  const handleCopyLinkLive = async (orderId) => {
    try {
      const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      const base = "https://sp.bbbb.com.la";
      const url = shopId ? `${base}/shop/${shopId}/order-confirm/${orderId}` : `${base}/order-confirm/${orderId}`;
      await navigator.clipboard.writeText(url);
      successSwal("ກ໋ອບປີ່ລິ້ງສຳເລັດແລ້ວ!");
    } catch (error) {
      console.error("Copy failed: ", error);
    }
  };

  const mapStatusColor = (status) => {
    switch (status) {
      case "COMPLETED":
      case "SHIPPING_COMPLETED":
        return "success";
      case "CANCELLED":
        return "danger";
      case "PENDING":
        return "warning";
      case "USERCONFIRM":
        return "info";
      case "READY_TO_SHIPPING":
      case "READYTOSHIPPING":
        return "primary";
      case "PRINT_ORDER":
        return "secondary";
      default:
        return "light";
    }
  };
  const mapStatusText = (status) => {
    switch (status) {
      case "COMPLETED":
      case "SHIPPING_COMPLETED":
        return "white";
      case "CANCELLED":
        return "white";
      case "PENDING":
        return "dark";
      case "USERCONFIRM":
        return "dark";
      case "READY_TO_SHIPPING":
      case "READYTOSHIPPING":
        return "white";
      case "PRINT_ORDER":
        return "white";
      default:
        return "dark";
    }
  };

  if (!loading && orderGroupTotal <= 0) return <EmptyOrderList />;
// HFdfjdsgjrgjvndijfdfsljre
  return (
    <>
    <Table responsive style={{ minHeight: "40vh" }}>
      <thead style={{ background: LINEAR_GRADIENT_BG_SP, color: COLOR_WHITE }}>
        <tr style={{ whiteSpace: "nowrap" }}>
          <th style={{ textAlign: "center", borderBottom: "none" }}>
            <Form.Check
              type="checkbox"
              id="ລຳດັບ"
              label="ລຳດັບ"
              checked={isSelectAll}
              onClick={() => {
                onSeletedAllOrder();
                if (isSelectAll) return setOrderGroupDownload([]);
                const _newOderGroupList = [];
                for (const _orderGroup of orderGroupList) {
                  if (_orderGroup?.orders?.length > 0) _newOderGroupList.push(_orderGroup);
                }
                setOrderGroupDownload(_newOderGroupList);
              }}
            />
          </th>
          <th style={{ borderBottom: "none" }}>ເລກທີໃບສັ່ງຊື້</th>
          <th style={{ borderBottom: "none" }}>ຂົນສົ່ງ</th>
          {/* <th style={{ borderBottom: "none", width: "50px" }}>ຫົວຂໍ້</th> */}
          <th style={{ borderBottom: "none",textAlign:"center" }}>ລູກຄ້າ</th>
          {/* <th style={{ borderBottom: "none" }}>ຮູບຊໍາລະ</th> */}
          <th style={{ borderBottom: "none" }}>ປະເພດ</th>
          <th style={{ borderBottom: "none" }}>ສະຖານະ</th>
          <th style={{ borderBottom: "none" }}>ຈ່າຍຄ່າເຄື່ອງ</th>
          <th style={{ borderBottom: "none" }}>ຊໍາລະ</th>
          <th style={{ borderBottom: "none" }}>ລວມທັງໝົດ</th>
          <th style={{ borderBottom: "none" }}>ວັນທີ</th>
          <th style={{ width: "100px", borderBottom: "none", flex: "2" }}>ຈັດການ</th>
        </tr>
      </thead>
      <tbody>
        {orderGroupList.map((order, index) => {
          const _checkedOrderGroup = selectedIds.filter((id) => id === order?.id);
          const orderType = order?.type || order?.orders?.[0]?.type;
          return (
            <tr key={"order" + index} style={{ borderBottom: "1px solid #e9ecef" }}>
              {isSelectAll ? (
                <td>
                  <Form.Check
                    type="checkbox"
                    label={index + 1 + _limit * (_skip - 1)}
                    checked={true}
                    disabled
                  />
                </td>
              ) : (
                <td>
                  <Form.Check
                    checked={_checkedOrderGroup.length > 0}
                    onChange={() => getSeletedOrder(order?.id, order)}
                    type="checkbox"
                    id={index + 1 + _limit * (_skip - 1)}
                    label={index + 1 + _limit * (_skip - 1)}
                  />
                </td>
              )}
              <td
                onClick={() => {
                  setSelectedOrderGroup(order);
                  if (orderType === "SALE_PAGE")
                    return gotoOrderGroupDetail(order?.id, order);
                }}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  color: "#371895",
                  cursor: order?.status !== "COMPLETED" || orderType === "SALE_PAGE" ? "pointer" : "default",
                  textDecoration: order?.status !== "COMPLETED" || orderType === "SALE_PAGE" ? "underline" : "none",
                }}
              >
                <p className="text-wrap" style={{ marginBottom: "1px" }}>{order?.code ?? "-"}</p>
                <p className="text-wrap" style={{ fontSize: "12px" }}>
                  ເລກຂົນສົ່ງ: {"-"}
                </p>
              </td>
              <td style={{ width: 120, maxWidth: 120 }}>
                <p style={{ width: 120, maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {/* {convertDeliveryMethod(order?.destinationLogistic ?? "-")} */}
                  {/* <span>{false ? <MdCheckCircle style={{ color: "green" }} /> : <MdOutlineInfo />}</span> */}
                  {order?.destinationLogistic || "-"}
                </p>
              </td>
              {/* <td
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: 200,
                }}
              >
                {order?.note ?? "-"}
              </td> */}
              <td>
                <div className="customer-info">
                  {/* <Image
                    alt="customer"
                    src={!_.isEmpty(order?.createdBy?.image) ? order?.createdBy?.image : "../image/noPhoto.png"}
                    style={{
                      width: "40px",
                      height: "40px",
                      maxWidth: "40px",
                      maxHeight: "40px",
                    }}
                    thumbnail
                  /> */}
                  <p style={{ fontSize: "12px", marginTop: "1px",textAlign:"center" }}>
                    {order?.customerName !== "" && order?.customerName ? order?.customerName : order?.userConfirm?.name ||"-"}
                  </p>
                </div>
              </td>
              {/* <td>
                {order?.transfer ? (
                  <div
                    style={{ width: "50px", height: "60px", cursor: "pointer", overflow: "hidden", borderRadius: "4px" }}
                    onClick={() => {
                      setSelectedImage && setSelectedImage(order?.transfer);
                      setshowImageModal && setshowImageModal(true);
                    }}
                  >
                    <Image alt="paments" src={imageRender(order?.transfer)} style={{ width: "50px", height: "60px" }} />
                  </div>
                ) : (
                  "-"
                )}
              </td> */}
              <td>{orderType ?? "-"}</td>
              <td>
                <Badge bg={mapStatusColor(order?.status)} text={mapStatusText(order?.status)}>
                  {convertOrderStatus(order?.status)}
                </Badge>
              </td>
              <td>
                <Badge bg={order?.payment === "CASH" || order?.payment==="TRANSFER" ? "secondary" : "danger"}>
                  {order?.payment === "CASH" || order?.payment==="TRANSFER" ? "ຕົ້ນທາງ" : "ປາຍທາງ"}
                </Badge>
              </td>
              <td style={{ color: order?.isPaymented ===true ? "green" : "red", whiteSpace: "nowrap" }}>
                {order?.isPaymented ===true ? "ຊໍາລະແລ້ວ" : "ຍັງບໍ່ຊໍາລະ"}
              </td>

              <td style={{ fontWeight: "bold" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ whiteSpace: "nowrap" }}>₭ {numberFormat(order?.totalPrice ?? 0)}</div>
                  <div style={{ whiteSpace: "nowrap" }}>฿ {numberFormat(order?.sumPriceBaht ?? 0)}</div>
                  <div style={{ whiteSpace: "nowrap" }}>$ {numberFormat(order?.sumPriceUsd ?? 0)}</div>
                </div>
              </td>
              <td>{moment(order?.createdAt).format("DD/MM/YYYY HH:mm")}</td>
              <td>
                <DropdownButton id="dropdown-item-button" variant="outline-secondary" title="">
                  <Dropdown.Item
                    as="button"
                    onClick={() => {
                      setSelectedOrderGroup(order);
                      setshowDetailModal(true);
                    }}
                  >
                    ລາຍລະອຽດ
                  </Dropdown.Item>
                  {/* <Dropdown.Item
                    as="button"
                    disabled={order?.status === "COMPLETED" || order?.status === "CANCELLED" ? true : false}
                    onClick={() => {
                      setSelectedOrderGroup(order);
                      handleOrderStatusChange && handleOrderStatusChange();
                    }}
                  >
                    ແກ້ໄຂອໍເດີ້
                  </Dropdown.Item> */}
                  {/* <Dropdown.Item as="button" onClick={() => handleCopyLinkLive(order?.id)}>
                    ຄັດລ໋ອກລິ້ງ
                  </Dropdown.Item>
                  <Dropdown.Item
                    as="button"
                    hidden={!isUseLogistics}
                    disabled={order?.status === "COMPLETED" || order?.status === "READY_TO_SHIPPING" ? true : false}
                    onClick={() => handleCreatePreOrder && handleCreatePreOrder(order)}
                  >
                    ຈັດສົ່ງ
                  </Dropdown.Item> */}
                </DropdownButton>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>

    {orderGroupTotal > 0 && (
      <div className="d-flex justify-content-center mt-3 mb-3">
        <ReactPaginate
          previousLabel={t("previous_pagination_title")}
          onPageChange={(event) => {
            setIsSelectAll(false);
            setSelectedIds([]);
            setSkip(event.selected + 1);
          }}
          breakLabel="..."
          pageRangeDisplayed={2}
          pageCount={Math.ceil(orderGroupTotal / _limit)}
          marginPagesDisplayed={2}
          renderOnZeroPageCount={null}
          containerClassName={"pagination justify-content-center"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
          forcePage={_skip - 1}
          nextLabel={t("next_pagination_title")}
        />
      </div>
    )}

    <Modal
      size="lg"
      centered
      scrollable
      show={showDetailModal}
      onHide={() => setshowDetailModal(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>ລາຍລະອຽດອໍເດີ້</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SalepageOrderDetail selectedOrderGroup={selectedOrderGroup} />
      </Modal.Body>
    </Modal>

    <Modal centered show={showImageModal} onHide={() => setshowImageModal(false)}>
      <Modal.Body className="text-center">
        {selectedImage ? <Image src={imageRender(selectedImage)} fluid /> : null}
      </Modal.Body>
    </Modal>
    </>
  );
}

export default SalepageOrderList
